import { ReactNode } from "react";

interface IEmpty {
  message: string;
  icon?: ReactNode;
}
export const Empty = (props: IEmpty) => {
  const { icon, message } = props;
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center space-y-4">
      {icon || null}
      <p className="text-subline">{message}</p>
    </div>
  );
};
